import { render, staticRenderFns } from "./CustomerSpan.vue?vue&type=template&id=43356c8d&"
import script from "./CustomerSpan.vue?vue&type=script&lang=js&"
export * from "./CustomerSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports